var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonCircle = function SvgPersonCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_459348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_459348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60509 19.411C5.64904 18.9699 5.79021 18.5439 6.01845 18.1639C6.24669 17.7838 6.55633 17.4591 6.92509 17.213L9.10809 15.759C9.67109 15.383 9.71609 14.555 9.26109 14.054C8.56109 13.284 7.74609 12.142 7.74609 11C7.74609 9 7.99609 5 11.9961 5C15.9961 5 16.2461 9 16.2461 11C16.2461 12.142 15.4311 13.284 14.7311 14.054C14.2761 14.554 14.3211 15.384 14.8841 15.759L17.0661 17.213C17.435 17.459 17.7449 17.7837 17.9733 18.1637C18.2017 18.5438 18.343 18.9698 18.3871 19.411L18.6361 21.901C18.6499 22.04 18.6345 22.1803 18.5908 22.313C18.5471 22.4456 18.476 22.5676 18.3823 22.6712C18.2886 22.7747 18.1742 22.8574 18.0465 22.9141C17.9189 22.9707 17.7808 23 17.6411 23H6.35109C6.21133 23 6.07313 22.9707 5.94539 22.914C5.81765 22.8573 5.70321 22.7745 5.60946 22.6708C5.51571 22.5672 5.44472 22.445 5.40108 22.3123C5.35744 22.1795 5.34211 22.0391 5.35609 21.9L5.60509 19.411Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "person-circle.e05a75eb4d098307c28307f92f616136.svg";